.count {
  background-color: var(--colors-text-inverse);
  color: var(--colors-primary-main);
  display: inline-block;
  width: 24px;
  height: 24px;
  border-radius: 12px;
  margin-left: 8px;
}
